import Icon from '../components/Icon.vue'

Icon.register({
  'microphone-alt-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1L476.3 336.3C488.7 312.2 496 285 496 256V208C496 199.2 488.8 192 480 192H464C455.2 192 448 199.2 448 208V256C448 273.9 444 290.8 437.3 306.2L410.7 285.7C413.8 276.3 416 266.5 416 256H372.3L330.9 224H416V192H330.7C324.8 192 320 188.4 320 184V168C320 163.6 324.8 160 330.7 160H416V128H330.7C324.8 128 320 124.4 320 120V104C320 99.6 324.8 96 330.7 96H416C416 43 373 0 320 0S224 43 224 96V141.4L45.5 3.4C38.5-2.1 28.4-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.5 6.2 53.9L594.5 508.6C601.5 514.1 611.6 512.8 617 505.8L636.6 480.6C642 473.6 640.8 463.5 633.8 458.1zM400 464H344V430.2C355.7 428.6 367.1 425.9 378 422.1L327.6 383.2C320.9 383.6 314.1 384.1 307.2 383.4 251.4 377.9 208.5 334.8 196 281.5L144 241.3V248.2C144 337.8 208 417.7 296 429.9V464H240C231.2 464 224 471.2 224 480V496C224 504.8 231.2 512 240 512H400C408.8 512 416 504.8 416 496V480C416 471.2 408.8 464 400 464z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microphone-alt-slash.js
// module id = LuA1
// module chunks = 144